import { Link } from "react-router-dom";
import "./GetInTouch.css";

const GetInTouch = () => {
  return (
    <section className="cta-band">
      <div className="section-shell">
        <div className="cta-band__panel">
          <div className="cta-band__copy">
            <span className="eyebrow">Why Teams Call Us In</span>
            <h2 className="cta-band__title">
              When commercialization starts to outpace the operating model.
            </h2>
            <p className="cta-band__text">
              The strongest launches are not just product stories. They are
              systems stories. We help teams tighten sales operations, reporting,
              and execution so growth does not create chaos.
            </p>
          </div>

          <div className="cta-band__details">
            <div className="cta-band__pillars">
              <span className="pill">Launch planning</span>
              <span className="pill">CRM + workflow design</span>
              <span className="pill">Revenue analytics</span>
            </div>
            <Link to="/contact" className="button button--primary">
              Get in Touch
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default GetInTouch;
